var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row align-items-center py-2" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("p", { staticClass: "lead text-primary font-weight-bold mb-0" }, [
        _vm._v("\n            " + _vm._s(_vm.commitments.title) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-5 col-md-4 col-xl-2 pt-1" }, [
      _c("div", { staticClass: "media text-white" }, [
        _c("span", {
          staticClass:
            "mr-1 align-self-center icon h1 mb-0 pb-0 icon-voucher-tag",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "media-body align-self-center" }, [
          _c("a", {
            staticClass: "d-block text-white o-link-arrow",
            attrs: {
              href: _vm.commitments.commitment1Link,
              "data-oevent-category": "footer",
              "data-oevent-action": "promos_exclusives",
              "data-oevent-label": _vm.commitments.commitment1Link,
            },
            domProps: { innerHTML: _vm._s(_vm.commitments.commitment1Text) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-7 col-md-4 col-xl-2 pt-1" }, [
      _c("div", { staticClass: "media text-white" }, [
        _c("span", {
          staticClass: "mr-1 align-self-center icon h1 mb-0 pb-0 icon-Safety",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "media-body align-self-center" }, [
          _c("a", {
            staticClass: "d-block text-white o-link-arrow",
            attrs: {
              href: _vm.commitments.commitment2Link,
              "data-oevent-category": "footer",
              "data-oevent-action": "paiement_100_securise",
              "data-oevent-label": _vm.commitments.commitment2Link,
            },
            domProps: { innerHTML: _vm._s(_vm.commitments.commitment2Text) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-5 col-md-4 col-xl-2 pt-1" }, [
      _c("div", { staticClass: "media text-white" }, [
        _c("span", {
          staticClass:
            "mr-1 align-self-center icon h1 mb-0 pb-0 icon-Fast-delivery",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "media-body align-self-center" }, [
          _c("a", {
            staticClass: "d-block text-white o-link-arrow",
            attrs: {
              href: _vm.commitments.commitment3Link,
              "data-oevent-category": "footer",
              "data-oevent-action": "livraison_gratuite",
              "data-oevent-label": _vm.commitments.commitment3Link,
            },
            domProps: { innerHTML: _vm._s(_vm.commitments.commitment3Text) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-7 col-md-4 col-xl-2 pt-1" }, [
      _c("div", { staticClass: "media text-white" }, [
        _c("span", {
          staticClass:
            "mr-1 align-self-center icon h1 mb-0 pb-0 icon-store-locator",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "media-body align-self-center" }, [
          _c("a", {
            staticClass: "d-block text-white o-link-arrow",
            attrs: {
              href: _vm.commitments.commitment4Link,
              "data-oevent-category": "footer",
              "data-oevent-action": "retrait_sous_2h_d_un_mobile_en_boutique",
              "data-oevent-label": _vm.commitments.commitment4Link,
            },
            domProps: { innerHTML: _vm._s(_vm.commitments.commitment4Text) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-5 col-md-4 col-xl-2 pt-1" }, [
      _c("div", { staticClass: "media text-white" }, [
        _c("span", {
          staticClass:
            "mr-1 align-self-center icon h1 mb-0 pb-0 icon-control-centre",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "media-body align-self-center" }, [
          _c("a", {
            staticClass: "d-block text-white o-link-arrow",
            attrs: {
              href: _vm.commitments.commitment5Link,
              "data-oevent-category": "footer",
              "data-oevent-action": "a_vos_cotes_24h24",
              "data-oevent-label": _vm.commitments.commitment5Link,
            },
            domProps: { innerHTML: _vm._s(_vm.commitments.commitment5Text) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-7 col-md-4 col-xl-2 pt-1" }, [
      _c("div", { staticClass: "media text-white" }, [
        _c("span", {
          staticClass:
            "mr-1 align-self-center icon h1 mb-0 pb-0 icon-calendar-21",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "media-body align-self-center" }, [
          _c("a", {
            staticClass: "d-block text-white o-link-arrow",
            attrs: {
              href: _vm.commitments.commitment6Link,
              "data-oevent-category": "footer",
              "data-oevent-action": "droit_de_retractation__21_jours",
              "data-oevent-label": _vm.commitments.commitment6Link,
            },
            domProps: { innerHTML: _vm._s(_vm.commitments.commitment6Text) },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }